// src/components/DynamicSuccess.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Typography } from '@mui/material';

const providerNames: Record<string, string> = {
	jobadder: 'JobAdder',
	bullhorn: 'Bullhorn',
	vincere: 'Vincere',
};

const DynamicSuccess = ({ provider }: { provider: string }) => {
	const displayName = providerNames[provider] || 'your ATS integration';

	return (
		<div className='flex h-screen items-center justify-center bg-gray-100 p-4'>
			<Card className='w-full max-w-xl rounded-2xl shadow-lg'>
				<CardContent className='space-y-4 p-8 text-center'>
					<Typography
						variant='h2'
						component='h2'
						className='font-semibold'
					>
						🎉 Integration Successfully!
					</Typography>
					<Typography
						variant='body1'
						className='text-lg text-gray-700'
					>
						You can now close this tab and use {displayName} iframe to fetch the
						candidate data.
					</Typography>
				</CardContent>
			</Card>
		</div>
	);
};

export default DynamicSuccess;
